import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  es: {
    translation: {
      login: 'Iniciar Sesion',
      register: 'Registrarse',
      email: 'Correo Electronico',
      password: 'Contrasena',
      fullName: 'Nombre Completo',
      dashboard: 'Panel',
      tenants: 'Empresas',
      users: 'Usuarios',
      packages: 'Paquetes',
      templates: 'Plantillas',
      addons: 'Complementos',
      tasks: 'Tareas',
      documents: 'Documentos',
      billing: 'Facturacion',
      integrations: 'Integraciones',
      auditLogs: 'Registro de Auditoria',
      requests: 'Solicitudes',
      logout: 'Cerrar Sesion',
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      create: 'Crear',
      search: 'Buscar',
      filter: 'Filtrar',
      status: 'Estado',
      actions: 'Acciones',
      loading: 'Cargando...',
      error: 'Error',
      success: 'Exito',
    },
  },
  en: {
    translation: {
      login: 'Login',
      register: 'Register',
      email: 'Email',
      password: 'Password',
      fullName: 'Full Name',
      dashboard: 'Dashboard',
      tenants: 'Companies',
      users: 'Users',
      packages: 'Packages',
      templates: 'Templates',
      addons: 'Add-ons',
      tasks: 'Tasks',
      documents: 'Documents',
      billing: 'Billing',
      integrations: 'Integrations',
      auditLogs: 'Audit Logs',
      requests: 'Requests',
      logout: 'Logout',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      search: 'Search',
      filter: 'Filter',
      status: 'Status',
      actions: 'Actions',
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'es',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
